export const mapApiResponseToForm = (apiResponse = {}) => ({
  subject: apiResponse?.subject,
  text: apiResponse?.content,
  buildingEmailAddresses: apiResponse?.building_email_addresses,
})

export const required = value => (value ? undefined : "Required")
